export default [
  {
    text: 'Есть',
    value: 'yes',
  },
  {
    text: 'По желанию',
    value: 'optional',
  },
  {
    text: 'Нет',
    value: 'no',
  },
];
